import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useSilver } from "@/context/SilverContext";
import { PostcodeSearch } from "@/components/silver/tool/PostcodeSearch";
import { PatchStrip } from "@/components/silver/tool/PatchStrip";
import { openWorkspace } from "@/lib/urlState";

export function BeginButton({ className = "", testId = "begin-btn" }) {
  const { areas, filters } = useSilver();
  return (
    <AnimatePresence>
      {areas.length > 0 && (
        <motion.button type="button" className={`btn-primary ${className}`} onClick={() => openWorkspace(areas, filters)}
          initial={{ opacity: 0, y: 12, scale: 0.94 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 8, scale: 0.96, transition: { duration: 0.2 } }}
          transition={{ type: "spring", stiffness: 300, damping: 24 }} data-testid={testId}>
          Let's start marketing <ArrowUpRight className="h-5 w-5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}

export default function LandingSearch() {
  const { areas } = useSilver();
  return (
    <section id="build" className="relative isolate scroll-mt-4" data-testid="landing-search-section">
      <div className="pointer-events-none absolute inset-0 -z-10" aria-hidden="true">
        <div className="absolute inset-0 bg-[#0C2010]/70" style={{ maskImage: "linear-gradient(to bottom, transparent, black 160px, black calc(100% - 160px), transparent)", WebkitMaskImage: "linear-gradient(to bottom, transparent, black 160px, black calc(100% - 160px), transparent)" }} />
        <div className="absolute inset-0 opacity-60" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px)", backgroundSize: "28px 28px", maskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)", WebkitMaskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)" }} />
        <div className="absolute left-1/2 top-0 h-px w-[80%] -translate-x-1/2 bg-gradient-to-r from-transparent via-[#96C11F]/50 to-transparent" />
      </div>

      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="eyebrow">Your patch</p>
            <h2 className="mt-6 text-5xl font-extrabold leading-[0.98] tracking-[-0.05em] sm:text-6xl lg:text-[4.5rem]">Find your homeowner audience.</h2>
          </div>
          <p className="self-end text-base leading-relaxed text-white/65 sm:text-[17px] lg:col-span-6 lg:col-start-7">
            Enter the postcode districts you want to target — add as many as you need, or paste a whole territory. Then begin, and build your audience in a dedicated workspace.
          </p>
        </div>

        <div className="mt-12">
          <PostcodeSearch variant="hero" />
          <div className="mt-5 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
            <PatchStrip />
            <BeginButton className="shrink-0 !px-9 !py-5 text-lg" testId="landing-begin-btn" />
          </div>
          {areas.length > 0 && (
            <p className="mt-4 font-ui text-[11px] text-white/40" data-testid="landing-begin-hint">Opens your audience workspace in a new tab.</p>
          )}
        </div>
      </div>
    </section>
  );
}
